import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Amplify } from 'aws-amplify';
import { getCurrentUser } from 'aws-amplify/auth';
import { theme } from './theme';
import { awsConfig } from './aws-config';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Empresas from './pages/Empresas';
import Certificados from './pages/Certificados';
import Series from './pages/Series';
import Comprobantes from './pages/Comprobantes';
import CrearComprobante from './pages/CrearComprobante';
import Usuarios from './pages/Usuarios';

Amplify.configure(awsConfig);

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      await getCurrentUser();
      setIsAuthenticated(true);
    } catch {
      setIsAuthenticated(false);
    }
  };

  const handleLogout = () => {
    // Limpiar estado de autenticación
    setIsAuthenticated(false);
    
    // Limpiar todo el localStorage y sessionStorage
    localStorage.clear();
    sessionStorage.clear();
  };

  if (isAuthenticated === null) {
    return null; // Loading
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" /> : <Login onLogin={() => setIsAuthenticated(true)} />
          } />
          <Route path="/" element={
            isAuthenticated ? (
              <AuthProvider>
                <Layout onLogout={handleLogout} />
              </AuthProvider>
            ) : (
              <Navigate to="/login" />
            )
          }>
            <Route index element={<Navigate to="/comprobantes" replace />} />
            <Route path="empresas" element={<Empresas />} />
            <Route path="certificados" element={<Certificados />} />
            <Route path="usuarios" element={<Usuarios />} />
            <Route path="series" element={<Series />} />
            <Route path="comprobantes" element={<Comprobantes />} />
            <Route path="crear-comprobante" element={<CrearComprobante />} />
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
